<form [formGroup]="datiGeneraliForm" (ngSubmit)="save();">
     <app-dati-generali-fascicolo-common [request]="request" [fascicolo]="fascicolo" [inserimento]="inserimento" [datiGeneraliForm]="datiGeneraliForm" (changedFondoRischiState)="changedFondoRischiState()"></app-dati-generali-fascicolo-common>
  <app-protocol-fascicolo-form [fascicolo]="fascicolo" (protocolDataChange)="onDataProtocol($event)" [dataView]="protocollo" />


     <div class="row container_fieldset">
      <div class="col-sm-12">
          <fieldset class="form-group">
               <legend>Decreto ingiuntivo</legend>

               <div textInput class="col-sm-3" [labelInput]="'Numero decreto'" formControlName="numDecretoIngiuntivo"
                    [(ngModel)]="request.fascicolo.numDecretoIngiuntivo">
               </div>

               <div textInput class="col-sm-3" [labelInput]="'Num. registro generale'"
                    formControlName="numRegistroGenerale" [(ngModel)]="request.fascicolo.numRegistroGenerale">
               </div>

               <div datePickerInput class="col-sm-3" [labelInput]="'Data emissione'"
                    formControlName="dataEmissioneDecretoIngiuntivo"
                    [(ngModel)]="request.fascicolo.dataEmissioneDecretoIngiuntivo">
               </div>

               <div datePickerInput class="col-sm-3" [labelInput]="'Data deposito'"
                    formControlName="dataDepositoDecretoIngiuntivo"
                    [(ngModel)]="request.fascicolo.dataDepositoDecretoIngiuntivo">
               </div>
          </fieldset>
        </div>
     </div>

     <div class="row container_fieldset">
        <div class="col-sm-12">
          <fieldset class="form-group">
               <legend>Formula esecutiva</legend>

               <div datePickerInput class="col-sm-3" [labelInput]="'Data richiesta apposizione'"
                    formControlName="dataRichiestaApposizione" [(ngModel)]="request.fascicolo.dataRichiestaApposizione">
               </div>

               <div datePickerInput class="col-sm-3" [labelInput]="'Data apposizione formula esecutiva'"
                    formControlName="dataApposizioneFormulaEsecutiva"
                    [(ngModel)]="request.fascicolo.dataApposizioneFormulaEsecutiva"></div>

               <div datePickerInput class="col-sm-3" [labelInput]="'Data rinuncia copie'"
                    formControlName="dataRitiroCopie" [(ngModel)]="request.fascicolo.dataRitiroCopie"></div>

               <div textInput class="col-sm-3" [labelInput]="'Cancelliere'" formControlName="cancelliere"
                    [(ngModel)]="request.fascicolo.cancelliere"></div>
          </fieldset>
        </div>
     </div>

     <div class="row">
          <div textAreaInput class="form-group col-xs-12 col-sm-12" [labelInput]="'Note'" formControlName="note"
               [(ngModel)]="request.fascicolo.note"></div>
     </div>

     <div>
      <h3 class="title1level">Campi personalizzati</h3>
          <app-fascicolo-metadata-form *ngIf="!fascicolo.id && fascicolo.tipoFascicolo.id"
            [tipoFascicolo]="fascicolo.tipoFascicolo.id"
            (metadataListChange)="onRetrieve($event)"
            (formChange)="isFormMetadataValid($event)">
          </app-fascicolo-metadata-form>
          <app-fascicolo-metadata-form *ngIf="fascicolo.id && fascicolo.tipoFascicolo.id"
            [fascicolo]="request.fascicolo"
            (metadataListChange)="onRetrieve($event)"
            (formChange)="isFormMetadataValid($event)">
          </app-fascicolo-metadata-form>
    </div>

     <div class="row">
          <p class="mandatory col-sm-12">
               <em>* Campi obbligatori</em>
          </p>
     </div>
     <div *ngIf="checkFondoRischiRemoved && !request.fascicolo.flagFondoRischi" class="row">
          <div class="col-sm-12 form-group">
               <p *ngIf="checkFondoRischiRemoved" confermaCambioFr #confermaCambioFrModifica
                    (onReturn)="notifyConferma($event)"></p>
          </div>
     </div>

     <div [ngClass]="minervaWizard ? 'wizard-buttons' : ''" class="row">
          <p class="col-sm-3 col-xs-6">
               <button type="button" class="btn btn-outline-secondary btn-block"
                    (click)="resetForm.emit()">Reset</button>
          </p>
          <p submitButton class="col-sm-3 col-xs-6 col-sm-offset-6" [labelButton]="minervaWizard ? 'Prosegui' : 'Salva'" [disabled]=" (checkFondoRischiRemoved && !request.fascicolo.flagFondoRischi ? !confermaFrChangeChecked : false) ||
														( (changeFondoRischi && !request.fascicolo.dataVariazioneFondoRischi) && ( !inserimento ) && ( !wizard ) ) ||
														!datiGeneraliForm.valid || !metadataFormValid"></p>
     </div>
</form>
